"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

require("moment/locale/ar");

require("moment/locale/en-gb");

var _reactPopper = require("react-popper");

var _outsideClick = _interopRequireDefault(require("./outside-click"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var WeekPicker =
/*#__PURE__*/
function (_Component) {
  _inherits(WeekPicker, _Component);

  function WeekPicker(props) {
    var _this;

    _classCallCheck(this, WeekPicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WeekPicker).call(this, props));
    var year = (0, _moment.default)().year();
    var month = (0, _moment.default)().month();
    _this.state = {
      dates: [],
      weeks: [],
      month: month,
      year: year,
      row: 0,
      selected: "",
      selectedWeek: "",
      isOpen: false,
      displayWeek: "",
      locale: _this.props.locale
    };
    return _this;
  }

  _createClass(WeekPicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setLocale();
      this.setUpDates();
    }
  }, {
    key: "setLocale",
    value: function setLocale() {
      _moment.default.locale(this.state.locale);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState({
        isOpen: !this.state.isOpen
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.setState({
        isOpen: true
      });
    }
  }, {
    key: "collapse",
    value: function collapse() {
      this.setState({
        isOpen: false
      });
    }
  }, {
    key: "setUpDates",
    value: function setUpDates() {
      var firstDay = (0, _moment.default)("1-" + (this.state.month + 1) + "-" + this.state.year, "DD-MM-YYYY").weekday();
      var date = 1;
      this.state.dates = [];
      this.state.weeks = [];
      this.state.row = 0;

      for (var i = 0; i < 41; i++) {
        if (i >= firstDay && date <= this.daysInMonth(this.state.month, this.state.year)) {
          this.state.dates.push(date);
          var weekNumber = (0, _moment.default)(date + "-" + (this.state.month + 1) + "-" + this.state.year, "DD-MM-YYYY").week();

          if (weekNumber && !this.state.weeks.includes(weekNumber)) {
            this.state.weeks.push(weekNumber);
          }

          date++;
        } else {
          this.state.dates.push("");
        }
      }

      this.setState({
        dates: this.state.dates,
        month: this.state.month,
        year: this.state.year,
        weeks: this.state.weeks,
        row: this.state.row
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      var year = (0, _moment.default)().year();
      var month = (0, _moment.default)().month();
      this.setState({
        dates: [],
        weeks: [],
        month: month,
        year: year,
        row: 0,
        selected: "",
        selectedWeek: "",
        displayWeek: "",
        isOpen: false
      }, function () {
        _this2.setUpDates();
      });
    }
  }, {
    key: "daysInMonth",
    value: function daysInMonth(month, year) {
      return (0, _moment.default)(month + 1 + "-" + year, "MM-YYYY").daysInMonth();
    }
  }, {
    key: "decrementMonth",
    value: function decrementMonth() {
      var date = (0, _moment.default)(this.state.month + 1 + "-" + this.state.year, "MM-YYYY").subtract(1, 'M');
      this.state.month = (0, _moment.default)(date).month();
      this.state.year = (0, _moment.default)(date).year();
      this.setUpDates();
    }
  }, {
    key: "incrementMonth",
    value: function incrementMonth() {
      var date = (0, _moment.default)("1-" + (this.state.month + 1) + "-" + this.state.year, "DD-MM-YYYY").add(1, 'M');
      this.state.month = (0, _moment.default)(date).month();
      this.state.year = (0, _moment.default)(date).year();
      this.setUpDates();
    }
  }, {
    key: "checkWeek",
    value: function checkWeek(day, week) {
      var weekNumber = (0, _moment.default)(day + "-" + (this.state.month + 1) + "-" + this.state.year, "DD-MM-YYYY").week();

      if (weekNumber == week || this.state.weeks[0] == week && day == "") {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "setWeek",
    value: function setWeek(week) {
      _moment.default.locale("en-gb");

      this.state.selected = week + "-" + this.state.year;
      this.state.displayWeek = "Week " + week + " (" + (0, _moment.default)(this.state.month + 1, "MM").format("MMMM") + " " + this.state.year + ")";
      this.setLocale();
      this.setState({
        selected: this.state.selected,
        isOpen: false,
        selectedWeek: week,
        displayWeek: this.state.displayWeek
      });
    }
  }, {
    key: "isSelectedWeek",
    value: function isSelectedWeek(week) {
      if (this.state.selectedWeek == week) {
        return "selected-week";
      }
    }
  }, {
    key: "isSelectedRow",
    value: function isSelectedRow(week) {
      if (this.state.selectedWeek == week) {
        return "selected-row";
      }
    }
  }, {
    key: "getWeek",
    value: function getWeek() {
      return this.state.selected;
    }
  }, {
    key: "getMonth",
    value: function getMonth() {
      _moment.default.locale("en-gb");

      var month = _moment.default.months(this.state.month);

      this.setLocale();
      return month + " ";
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return _react.default.createElement(_outsideClick.default, {
        clicked: function clicked() {
          return _this3.collapse();
        }
      }, _react.default.createElement(_reactPopper.Manager, null, _react.default.createElement(_reactPopper.Target, null, _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", null, this.props.title), _react.default.createElement("div", {
        className: "input-btn-wrapper"
      }, _react.default.createElement("input", {
        className: "form-control datepicker",
        value: this.state.displayWeek,
        placeholder: this.props.placeholder,
        onFocus: function onFocus() {
          return _this3.show();
        }
      }), _react.default.createElement("button", {
        type: "button",
        className: "select-btn date-picker-select-position",
        onClick: function onClick() {
          return _this3.handleClick();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-calendar"
      }))))), this.state.isOpen ? _react.default.createElement(_reactPopper.Popper, {
        placement: "bottom-end",
        class: "week-popper-container"
      }, _react.default.createElement("div", {
        className: "week-picker-content"
      }, _react.default.createElement("div", {
        className: "week-picker-header"
      }, _react.default.createElement("div", {
        className: "week-picker-previous"
      }, _react.default.createElement("button", {
        className: "week-increment-btn",
        onClick: function onClick() {
          return _this3.decrementMonth();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-left"
      }))), _react.default.createElement("div", {
        className: "week-picker-next"
      }, _react.default.createElement("button", {
        className: "week-increment-btn",
        onClick: function onClick() {
          return _this3.incrementMonth();
        }
      }, _react.default.createElement("span", {
        className: "fa fa-angle-right"
      }))), _react.default.createElement("div", {
        className: "week-picker-month-label"
      }, this.getMonth(), this.state.year)), _react.default.createElement("table", {
        cellPadding: "0",
        cellSpacing: "0",
        className: "week-picker-table"
      }, _react.default.createElement("tbody", null, this.state.locale == "en-gb" && _react.default.createElement("tr", {
        className: "week-picker-header-row"
      }, _react.default.createElement("td", null), _react.default.createElement("td", null, "M"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "W"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "F"), _react.default.createElement("td", null, "S"), _react.default.createElement("td", null, "S")), this.state.locale == "en-us" && _react.default.createElement("tr", {
        className: "week-picker-header-row"
      }, _react.default.createElement("td", null), _react.default.createElement("td", null, "S"), _react.default.createElement("td", null, "M"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "W"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "F"), _react.default.createElement("td", null, "S")), this.state.locale == "ar" && _react.default.createElement("tr", {
        className: "week-picker-header-row"
      }, _react.default.createElement("td", null), _react.default.createElement("td", null, "S"), _react.default.createElement("td", null, "S"), _react.default.createElement("td", null, "M"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "W"), _react.default.createElement("td", null, "T"), _react.default.createElement("td", null, "F")), _react.default.createElement("tr", {
        className: "week-picker-table-spacer"
      }), this.state.weeks.map(function (week, rowIndex) {
        return _react.default.createElement("tr", {
          onClick: function onClick() {
            return _this3.setWeek(week);
          }
        }, _react.default.createElement("td", {
          className: "week-label " + _this3.isSelectedWeek(week)
        }, week), _this3.state.dates.map(function (date, dateIndex) {
          return _this3.checkWeek(date, week) ? _react.default.createElement("td", {
            className: _this3.isSelectedRow(week)
          }, date) : "";
        }));
      }))), _react.default.createElement("div", {
        className: "week-picker-bottom-container"
      }, _react.default.createElement("a", {
        className: "time-picker-clear",
        onClick: function onClick() {
          return _this3.clear();
        }
      }, "Clear")))) : ""));
    }
  }]);

  return WeekPicker;
}(_react.Component);

var _default = WeekPicker;
exports.default = _default;